import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps, MultiSelectDynamicFormField } from "../../types/types";
import { MultiSelectDynamic } from "../index";

export const MultiSelectDynamicField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
            <MultiSelectDynamic
                key={field.name}
                name={field.name}
                label={field.translationKeys.label}
                fieldConfig={field as MultiSelectDynamicFormField}
                readOnly={readOnly}
            />
        </Form.Item>
    );
};
